/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Должность для объединения.
 */
export interface JobTitleForUnionView { 
    /**
     * ID должности из табл JobTitles.
     */
    jobTitleId?: string;
    /**
     * ID организации. Определяется по пользователю.
     */
    parentOrganisationId?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    isAdminOnly?: boolean;
    /**
     * 
     */
    sortOrder?: number;
    /**
     * ID должности для объединения.
     */
    id?: string;
    /**
     * 
     */
    jobTitleName?: string;
    /**
     * кол-во участников объединения
     * @deprecated
     */
    membersCount?: number;
}

